import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { SafeUrl } from '@angular/platform-browser';
import { NotificationListService } from '../notification-list/notification-list.service';
import { NotificationListSend } from '../notification-list/model/notification-list.model';
import { SecurityService } from '../security/services/security.service';
import { APP_ROUTES } from '../app-routing.const';
import { SidebarStateFunction } from '../sidebar-menu/sidebar-menu.function';
import { ContractEditorHeaderState } from '../contract-editor/function/contract-editor-state.function';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  standalone: false
})
export class HeaderComponent {

  APP_ROUTES = APP_ROUTES;

  @Input() userName: string = '';
  @Input() userRole: string = '';
  @Input() profilePic: SafeUrl | string = './assets/logos/user/user-default.svg';

  /** Contract editor center zone */
  @Input() showEditor: boolean = false;
  @Input() contractState: string | undefined;

  recentNotifications: NotificationListSend[] = [];

  constructor(private router: Router,
              private securityService: SecurityService,
              private notificationListService: NotificationListService,
              protected sidebar: SidebarStateFunction,
              protected editorHeader: ContractEditorHeaderState) {}



  goToDashboard() {
    document.body.style.overflow = 'auto';
    this.router.navigate([APP_ROUTES.DASHBOARD]);
    this.router.navigate([APP_ROUTES.DASHBOARD]);
  }

  goToSettings() {
    this.router.navigate([APP_ROUTES.SETTINGS.PROFILE]);
  }

  logout() {
    this.securityService.logout();
  }

  // ---- Notifications ----
  loadNotifications() {
    this.notificationListService.getNotificationListUsersMinimal().subscribe({
      next: (notifs) => this.recentNotifications = (notifs || []).slice(0, 5),
      error: (err) => console.error('Error charging notifications', err)
    });
  }

  goToNotificationSettings() {
    this.router.navigate([APP_ROUTES.SETTINGS.NOTIFICATION]);
  }

  deleteNotification(uuid: string, event: Event) {
    event.stopPropagation();
    this.notificationListService.deleteNotification(uuid).subscribe({
      next: () => this.recentNotifications = this.recentNotifications.filter(n => n.uuid !== uuid),
      error: (err) => console.error('Error deleting notification', err)
    });
  }

  disableNotificationType(type: string, event: Event) {
    this.notificationListService.muteNotificationType(type).subscribe({
      next: () => this.loadNotifications(),
      error: (err) => console.error('Error muting notification type', err)
    });
  }

  viewAllNotifications() {
    this.router.navigate([APP_ROUTES.NOTIFICATION_LIST]);
  }

  // ---- Governys apps ----
  private open(url: string) { window.open(url, '_blank'); }
  goToScanClause() { this.open('https://sc.governys.com'); }
  goToExigate()    { this.open('https://eg.governys.com'); }
  goToDiliplan()   { this.open('https://dp.governys.com'); }
  goToAudiscope()  { this.open('https://as.governys.com'); }
  goToBillecho()   { this.open('https://be.governys.com'); }
  goToRiskout()    { this.open('https://ro.governys.com'); }
}